import React from 'react';
import { CheckCircle2, AlertCircle, AlertTriangle } from 'lucide-react';
import { getRdvPaymentView, formatEuro } from '../../utils/rdvPaymentDisplay';
import { resolveRdvPaymentTone, rdvPaymentToneClassName } from '../../utils/rdvPaymentTone';

function PaymentToneIcon({ tone }) {
  if (tone === 'success') {
    return <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-emerald-700" aria-hidden />;
  }
  if (tone === 'danger') {
    return <AlertCircle className="h-3.5 w-3.5 shrink-0 text-rose-700" aria-hidden />;
  }
  if (tone === 'warning') {
    return <AlertTriangle className="h-3.5 w-3.5 shrink-0 text-amber-800" aria-hidden />;
  }
  return null;
}

/**
 * Cellule paiement RDV — présentation mock (labels existants getRdvPaymentView).
 */
export default function MesCommandesRdvPaymentCell({ commande }) {
  const pay = getRdvPaymentView(commande);
  if (!pay) {
    return <span className="text-xs text-gray-400">—</span>;
  }

  const label = pay.summaryLabel || pay.modeLabel || '—';
  const tone = resolveRdvPaymentTone(commande);
  const toneClass = rdvPaymentToneClassName('cell', tone);

  return (
    <div
      className={`inline-flex flex-col gap-0.5 rounded-lg border px-2.5 py-1.5 text-xs min-w-[8.5rem] ${toneClass}`}
    >
      <span className="flex items-start gap-1 font-semibold leading-snug">
        <PaymentToneIcon tone={tone} />
        <span>{label}</span>
      </span>
      {!pay.isRefunded && pay.amountDueLater > 0.009 ? (
        <span className="text-[11px] opacity-90 tabular-nums pl-[1.125rem]">
          Reste : {formatEuro(pay.amountDueLater)}
        </span>
      ) : null}
      {pay.amountPaid > 0.009 && String(label).toLowerCase().includes('acompte') ? (
        <span className="text-[11px] opacity-90 tabular-nums pl-[1.125rem]">
          Reçu : {formatEuro(pay.amountPaid)}
        </span>
      ) : null}
    </div>
  );
}
